import { Injectable } from '@angular/core';
import { Http, ResponseContentType, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Statique } from "../utils/statique";
import { DialogService } from './dialog.service';
import { SearchCriteria } from '../utils/searchCriteria';
import { AuthHttp } from 'angular2-jwt';
import { Modules } from '../utils/enumeration';
import { DatePipe } from '@angular/common';

@Injectable()
export class ExportService {
	statique = Statique;
	Modules = Modules;
	constructor(
		private http: Http,
		private authHttp: AuthHttp,
		private dialogService: DialogService,
		private datePipe: DatePipe
	) {
	}

	async exportCsvFile(module: number, showPeride: boolean = false, criteria: SearchCriteria = null, exp?: number) { // params à changer selon le besoin

		let options = new RequestOptions({ responseType: ResponseContentType.Blob });
		if (exp) {
			criteria.export = exp;
		}
		if (!criteria)
			criteria = new SearchCriteria();
		criteria.module = module;

		try {
			let result;
			if (showPeride) {
				result = await this.dialogService.periodeInput("Periode of dates", "Please choose a periode of dates");
				if (result["dateDeb"])
					criteria.dateDeb = new Date(result["dateDeb"].year, result["dateDeb"].month, result["dateDeb"].day);
				if (result["dateFin"])
					criteria.dateFin = new Date(result["dateFin"].year, result["dateFin"].month, result["dateFin"].day);
			}
			this.authHttp.post("/api/export/csv", criteria, options).map(res => res.blob())
				.subscribe((data: Blob) => {
					var blob = data.slice(0, data.size, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
					this.downloadFile(blob, criteria.numAwbBol, module);
				});

		}
		catch (e) {

		}
	}

	downloadFile(data, fileName, module) {
		if (fileName && module == Modules.ETATAQUAI) {
			let mdate = new Date();
			let datee = this.datePipe.transform(mdate, 'yyyy-MM-dd_hh-mm');
			fileName = fileName + "_" + datee + ".xlsx";
		}
		else fileName = "data.xlsx";

		if (window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveBlob(data, fileName);
		}
		else {
			var link = document.createElement('a');
			link.href = window.URL.createObjectURL(data);
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

		}

	}

}



// WEBPACK FOOTER //
// ./src/app/services/export.service.ts